import React, { useEffect, useState } from 'react'
import ManageAdminCard from '../../components/ManageAdminCard'
import { useNavigate, useParams } from 'react-router-dom'
import Loader from '../../components/Loader'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'

const ManageAdmins = () => {
    const [admins, setAdmins] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const { organization } = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        const getAdmins = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/${organization}/admins`)
                setIsLoading(false)
                console.log(response)
                if (response) {
                    setAdmins(response.data)
                }
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response.data.message)
            }
        }

        getAdmins()
    }, [organization])

    return (
        <div className="shop-admins">
            <div className="admins-page-header">
                <h2 className="store-name">{organization}</h2>
                <p className='page-title'>Admins</p>
                <button
                    onClick={() => navigate(`/${organization}/admin/admins/new`)}
                    className='new-admins-btn'
                >Add New</button>
            </div>
            <div className="admins-list">
                {
                    admins?.length >= 0 && admins.map((admin) => (
                        <div className="admin-user" key={admin._id}>
                            <ManageAdminCard user={admin} />
                        </div >
                    ))
                }
            </div>
            {
                isLoading && <Loader />
            }
        </div>
    )
}

export default ManageAdmins